/**
 * @file QrExpiryTimerView.tsx
 * @copyright 2023 Boston Scientific Corporation
 * ********************************************************************************************************************
 * Copyright © 2023 Boston Scientific Corporation All rights reserved.
 *
 * This file and its contents are a product of Boston Scientific Corporation.  All software distributed by Boston
 * Scientific Neuromodulation is done so under a software license.  This file may not be copied or modified without
 * execution of the appropriate software license agreement with Boston Scientific Neuromodulation or explicit written
 * permission of Boston Scientific Neuromodulation.
 *
 * This file is provided as is, with no warranties of any kind including the warranties of design, merchantability and
 * fitness for a particular purpose, or arising from a course of dealing, usage or trade practice.
 *
 * Boston Scientific Neuromodulation shall have no liability with respect to the infringement of copyrights, trade
 * secrets or any patents by this file or any part thereof.
 *
 * In no event will Boston Scientific Neuromodulation be liable for any lost revenue or profits or other special,
 * indirect and consequential damages, even if Boston Scientific has been advised of the possibility of such damages,
 * as a result of the usage of this file and software for which this file is a part.
 * ********************************************************************************************************************
 *
 */
import React from "react";
import { BaseComponent } from "../home/base/BaseComponent";

/**
 * A type of Component state
 */
type CompState = { time: any, seconds: number };

/**
 * An interface definition for Component Props
 */
interface Props {
  expiredTime: number,
  expiryTrigger: any
}

/**
 * A class definition for LocationComponent
 */
export class QrExpiryTimerView extends BaseComponent<Props, CompState> {

  readonly time = 48*60*60;

  constructor(props: any) {
    super(props);
    this.state = { time: {}, seconds: this.time }; 
    this.timer = 0;
    this.startTimer = this.startTimer.bind(this);
    this.countDown = this.countDown.bind(this);
  }

  private onExpiryTrigger = () => {
    this.props.expiryTrigger();
  }

  timer: any;

  private secondsToTime(secs: number) {
    const d = Math.floor(secs / (3600 * 24));
    const h = Math.floor(secs % (3600 * 24) / 3600);
    const m = Math.floor(secs % 3600 / 60);
    const s = Math.floor(secs % 60);

    const dDisplay = d > 0 ? d + (d === 1 ? " day " : " days ") : " 00 ";
    const hDisplay = h > 0 ? h + (h === 1 ? "" : "") : "00";
    const mDisplay = m > 0 ? m + (m === 1 ? "" : "") : "00";
    const sDisplay = s > 0 ? s + (s === 1 ? "" : "") : "00";

    const obj = {
      "Day": dDisplay,
      "h": hDisplay.length <= 1 ? '0'+hDisplay : hDisplay,
      "m": mDisplay.length <= 1 ? '0'+ mDisplay : mDisplay,
      "s": sDisplay.length <= 1 ? '0'+ sDisplay : sDisplay
    };
    return obj;
  }

  componentDidMount() {
    this.logger.verbose('QrExpiryTimerComponent (mounted)', QrExpiryTimerView.name);
    const timeLeftVar = this.secondsToTime(this.state.seconds);
    this.setState({ time: timeLeftVar });
    this.startTimer();
  }

  private startTimer() {
    if (this.timer === 0 && this.state.seconds > 0) {
      this.timer = setInterval(this.countDown, 1000);
    }
  }

  private countDown() {
    // Remove one second, set state so a re-render happens.
    const seconds = this.state.seconds - 1;
    this.setState({
      time: this.secondsToTime(seconds),
      seconds: seconds,
    });

    // Check if we're at zero.
    if (seconds === 0) {
      this.onExpiryTrigger()
      clearInterval(this.timer);
    }
  }

  render() {
    return (
      <div style={{ marginTop: '1.5rem', display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
        <p>Expired In:  <b>{this.state.time.Day} &nbsp;{this.state.time.h}:{this.state.time.m}:{this.state.time.s}</b></p>
      </div>
    );
  }
}